import { render, staticRenderFns } from "./Cancelando.vue?vue&type=template&id=70245d32"
import script from "./Cancelando.vue?vue&type=script&lang=js"
export * from "./Cancelando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports